import { render, staticRenderFns } from "./RabattVorgaenge.vue?vue&type=template&id=0c2a5324&"
import script from "./RabattVorgaenge.vue?vue&type=script&lang=js&"
export * from "./RabattVorgaenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports